ko.bindingHandlers.gallerySlick = (function() {
  let addHiddenDivToBody = function() {
    let div = document.createElement('div');
    div.style.display = 'none';
    document.body.appendChild(div);
    return div;
  };

  let createSlide = function(templateName, viewModel) {
    let temporaryDiv = addHiddenDivToBody();
    let deferredElement = $.Deferred();
    let templateEl = document.getElementById(templateName);
    if (!templateEl) {
      templateName = 'unknown_field_entry_template';
    }
    ko.renderTemplate(
      templateName,
      viewModel,
      // We need to know when the template has been rendered,
      // so we can get the resulting DOM element.
      // The resolve function receives the element.
      {
        afterRender: function (nodes) {
          // Ignore any #text nodes before and after the modal element.
          let elements = nodes.filter(function(node) {
            return node.nodeType === 1; // Element
          });
          deferredElement.resolve(elements[0]);
        }
      },
      // The temporary div will get replaced by the rendered template output.
      temporaryDiv,
      'replaceNode'
    );
    // Return the deferred DOM element so callers can wait until it's ready for use.
    return deferredElement;
  };

  let initFirstSlide = function (vm) {
    try {
      let slick = $('#js-courseworkSlideHolder')[0].slick;
      if (slick && slick.$slides && slick.$slides[0]) {
        let slideEl = slick.$slides[0];
        vm.initSlide(slideEl);
        vm.currentFieldEntry(slideEl.vm || {});
        vm.resizeSlideMedia();
        vm.refreshSlick();
      } else {
        setTimeout(function () { initFirstSlide(vm); }, 100);
      }
    } catch(error) {
      setTimeout(function () { initFirstSlide(vm); }, 100);
    }
  };

  let initSlider = function (element, valueAccessor, allBindingsAccessor) {
    let $el = $(element);
    let parentVM = allBindingsAccessor().parent;
    let options = {
      infinite: false,
      slidesToShow: 1,
      arrows: false,
      dots: false,
      adaptiveHeight: true,
      useCSS: false,
      waitForAnimate: true,
      draggable: false,
      initialSlide: parentVM.initialSlideIndex()
    };

    // Clears the div
    $el.empty();

    // Creates the inner divs with images
    _.each(ko.unwrap(valueAccessor()), function(item) {
      createSlide(item.template_name(), item).pipe($).pipe(function($ui) {
        $el.append($ui);
      });
    });

    $el.off('init').on('init', function(event, slick) {
      initFirstSlide(parentVM);
    });

    $el.off('afterChange').on('afterChange', function(event, slick, currentSlide) {
      let slideEl = slick.$slides[currentSlide];
      if (_.isEmpty(slideEl)) return;
      parentVM.pauseCurrentSlide();
      parentVM.initSlide(slideEl);
      parentVM.currentFieldEntry(slideEl.vm || {});
      parentVM.currentSlideNumber(currentSlide + 1);
      parentVM.resizeSlideMedia();
    });

    // Initialize slick on the div, with provided options
    $el.slick(options);
  };

  // Initializes the carousel
  let init = function(element, valueAccessor, allBindingsAccessor) {
    initSlider(element, valueAccessor, allBindingsAccessor);

    // Handle disposal, if KO removes the element
    ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
      $(element).slick('unslick');
    });
  };

  // Update the control when the view model changes
  let update = function(element, valueAccessor, allBindingsAccessor) {
    // Dispose the old slider
    let $el = $(element);
    $el.slick('slickRemove', null, null, true);
    $el.slick('unslick');

    initSlider(element, valueAccessor, allBindingsAccessor);
  };

  return { init, update };
})();
